export default __webpack_public_path__ + "static/media/sand_mint.a181249d.png";